import React from "react";

const CatalogueSettings = () => {
  return <p>catalogue settings</p>;
};

export { CatalogueSettings };
